"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatComingSoonException = exports.InitFetchFailedException = exports.DeviationNotFoundException = exports.GroupInactiveException = exports.GroupNotFoundException = exports.UserSelfBlockedException = exports.UserBlockedException = exports.UserBannedException = exports.UserSuspendedException = exports.UserDeactivatedException = exports.ForbiddenException = exports.NotFoundException = exports.DaError = void 0;
const da_errors_1 = require("@wix/da-bootstrap-ng/lib/errors/da-errors");
const wix_errors_1 = require("@wix/wix-errors");
class DaError extends wix_errors_1.WixSystemError {
    constructor(msg, cause, opts = {}) {
        super(msg, Object.assign({ cause }, opts));
        // Used to identify errors inheriting from this class. More reliable than instanceof.
        this.isDaError = true;
    }
}
exports.DaError = DaError;
function makeCustomError(config) {
    const { name, httpStatusCode, errorCode, withStack = false } = config;
    return (msg, cause) => {
        const message = withStack ? msg : `${name}: ${msg}`;
        const error = new DaError(message, cause, {
            httpStatusCode,
            errorCode,
        });
        error.name = name;
        error.stack = withStack ? error.stack : undefined;
        return error;
    };
}
exports.NotFoundException = makeCustomError({
    name: 'NotFoundException',
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.ForbiddenException = makeCustomError({
    name: 'ForbiddenException',
    httpStatusCode: wix_errors_1.HttpStatus.FORBIDDEN,
});
exports.UserDeactivatedException = makeCustomError({
    name: 'UserDeactivatedException',
    errorCode: da_errors_1.ErrorCode.USER_DEACTIVATED,
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.UserSuspendedException = makeCustomError({
    name: 'UserSuspendedException',
    errorCode: da_errors_1.ErrorCode.USER_SUSPENDED,
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.UserBannedException = makeCustomError({
    name: 'UserBannedException',
    errorCode: da_errors_1.ErrorCode.USER_BANNED,
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.UserBlockedException = makeCustomError({
    name: 'UserBlockedException',
    errorCode: da_errors_1.ErrorCode.PAPI_ERROR,
    httpStatusCode: wix_errors_1.HttpStatus.UNAUTHORIZED,
});
exports.UserSelfBlockedException = makeCustomError({
    name: 'UserSelfBlockedException',
    errorCode: da_errors_1.ErrorCode.PAPI_ERROR,
    httpStatusCode: wix_errors_1.HttpStatus.UNAUTHORIZED,
});
exports.GroupNotFoundException = makeCustomError({
    name: 'GroupNotFoundException',
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.GroupInactiveException = makeCustomError({
    name: 'GroupInactiveException',
    errorCode: da_errors_1.ErrorCode.GROUP_INACTIVE,
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.DeviationNotFoundException = makeCustomError({
    name: 'DeviationNotFoundException',
    httpStatusCode: wix_errors_1.HttpStatus.NOT_FOUND,
});
exports.InitFetchFailedException = makeCustomError({
    name: 'InitFetchFailedException',
    errorCode: da_errors_1.ErrorCode.PAPI_ERROR,
    httpStatusCode: wix_errors_1.HttpStatus.INTERNAL_SERVER_ERROR,
});
exports.ChatComingSoonException = makeCustomError({
    name: 'ChatComingSoonException',
    errorCode: da_errors_1.ErrorCode.CHAT_COMING_SOON,
    httpStatusCode: wix_errors_1.HttpStatus.LOCKED,
});
//# sourceMappingURL=exceptions.js.map